import { CountryListSagaWatcher } from './Countries/saga';

export const entitiesModuleSaga = [CountryListSagaWatcher];
